import { Box, Flex } from "@chakra-ui/react";
import { Sidebar } from "./Sidebar";
import { useMobile } from "./hooks";

export const AppLayout = ({ children }: { children: React.ReactNode }) => {
  const isMobile = useMobile();

  return (
    <Flex
      w="100%"
      minH="100vh"
      direction={isMobile ? "column" : "row"}
      bg="gray.900"
      backgroundImage="radial-gradient(circle at 20% 0%, rgba(59, 130, 246, 0.12), transparent 34%), radial-gradient(circle at 80% 8%, rgba(139, 92, 246, 0.10), transparent 28%)"
      backgroundAttachment="fixed"
    >
      <Sidebar />
      <Box flex={1} overflowX="hidden" w={isMobile ? "100%" : undefined}>
        {children}
      </Box>
    </Flex>
  );
};
